import { useState } from "react";
import { Input, Button, Space } from "antd";
import { ThunderboltOutlined } from "@ant-design/icons";
import storage from "@/utils/store";
import "./index.less";
import { useNavigate } from "react-router-dom";
import Menu from "../Menu";
import classnames from "classnames";
import quickOrderPng from "@/images/icon-quickOrder.png";

const { Search } = Input;

const logo = require("@/images/logo.png");

const NavBar = ({ isFixNav = false, fixNavShow = false }) => {
  const navigate = useNavigate();

  const [serchVal, setSerchVal] = useState<string>();

  const goHome = () => {
    navigate("/home");
  };

  const onSearch = () => {
    storage.s.set("serchKey", serchVal);
    navigate("/safetyGas");
  };

  const gopage = () => {
    navigate("/quickOrder/dytOrder");
  };

  return (
    <div
      className={classnames([
        "nav-bar-wrapper",
        { isFixNav: isFixNav, fixNavShow: fixNavShow },
      ])}
    >
      <article className="max-width">
        <article className="nav-bar flex-b-c">
          <div className="logo flex-b-c shop-pc" onClick={goHome}>
            <img src={logo} alt="logo" />
          </div>
          <Menu />
          <Space className="search-wrapper" size="small">
            <Search
              value={serchVal}
              className="serch-input"
              placeholder="请输入要搜索的内容"
              onSearch={onSearch}
              onChange={(e) => {
                setSerchVal(e.target.value);
              }}
              enterButton
            />
            <Button
              className="btn"
              type="primary"
              icon={<ThunderboltOutlined style={{ fontSize: 16 }} />}
              onClick={gopage}
            >
              快速下单
            </Button>
            <img className="quick-order-png" src={quickOrderPng} onClick={gopage} alt="快速下单" />
          </Space>
        </article>
      </article>
    </div>
  );
};

export default NavBar;
